<template>
  <div class="checkboxes">
    <label id="limit-agree" :for="'agree-'+code" class="agree-title">
      <div>
        <input
            :class="check ? 'checkbox-none' : 'check-box'"
            type="checkbox"
            :id="'agree-'+code"
            v-model="check"
        />
      </div>
      <div>
        <img
            src="/images/icons/checkbox.png"
            :class="check ? '' : 'checkbox-none'"
        />
      </div>
      <div class="package_wrapper">
        <div>{{ name }}&nbsp;</div>
        <div class="package_price" v-if="isTvCheckout && !isPrepaidTvTariff" v-html="$options.filters.priceFilter(price)"></div>
        <div class="package_price" v-else-if="isTvCheckout && isPrepaidTvTariff" v-html="$options.filters.priceFilterWithoutMo(price)"></div>
        <div class="package_price" v-else v-html="$options.filters.priceFilter2(price)"></div>
      </div>
    </label>
  </div>
</template>

<script>
import TariffPackage from './TariffPackage';
export default TariffPackage;
</script>
